import {DomainEvent} from './DomainEvent';
import {Club} from '../resources/Club';

export class ClubUpdated extends DomainEvent<Club> {}
